import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import SecurityPageWrapper from '../security-page-wrapper/SecurityPageWrapper';
import CommonButton from '../../components/common-button/CommonButton';
import EmailSentIcon from '../../icons/components/EmailSentIcon';

import scss from '../Security.module.scss';

const EmailSent = () => {
  const { t } = useTranslation('securityPage');
  const navigate = useNavigate();

  const handleRedirectToOtp = useCallback(() => {
    navigate('/otp');
  }, [navigate]);

  useEffect(() => {
    const redirect = setTimeout(() => {
      handleRedirectToOtp();
    }, 8000);

    return () => {
      clearInterval(redirect);
    };
  }, [handleRedirectToOtp]);

  return (
    <SecurityPageWrapper>
      <div className={scss.form}>
        <EmailSentIcon className={scss['email-sent_icon']} />

        <h1 className={scss.title}>{t('emailWasSent')}</h1>

        <div className={scss.items}>
          <h4 className={scss.subtitle}>{t('checkEmail')}</h4>
        </div>

        <div className={scss.buttons}>
          <CommonButton styleColor='primary' maxWidth={190} onClick={handleRedirectToOtp}>
            {t('gotIt')}
          </CommonButton>
        </div>
      </div>
    </SecurityPageWrapper>
  );
};

export default EmailSent;
